/* LGCY feature layer v3.3 — countdown, hotspots, lookbook carousel,
   outline type, hero word split, wipes, cart bump */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- countdown ---- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-lgcy-countdown]').forEach(function (el) {
      if (el._lgcyCd) return;
      var target = new Date(el.getAttribute('data-target')).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-cd-d]');
      var hEl = el.querySelector('[data-cd-h]');
      var mEl = el.querySelector('[data-cd-m]');
      var sEl = el.querySelector('[data-cd-s]');
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.classList.add('lgcy-cd--live');
          clearInterval(el._lgcyCd);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      el._lgcyCd = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---- shop-the-look hotspots ---- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-lgcy-dot]');
    if (dot) {
      e.preventDefault();
      var spot = dot.closest('.lgcy-look__spot');
      var wasOpen = spot.classList.contains('is-open');
      document.querySelectorAll('.lgcy-look__spot.is-open').forEach(function (s) {
        s.classList.remove('is-open');
      });
      if (!wasOpen) spot.classList.add('is-open');
      return;
    }
    if (!e.target.closest('.lgcy-look__card')) {
      document.querySelectorAll('.lgcy-look__spot.is-open').forEach(function (s) {
        s.classList.remove('is-open');
      });
    }
  });

  /* ---- lookbook: drag to scroll + auto-scroll carousel ---- */
  function initLookbooks(root) {
    (root || document).querySelectorAll('[data-lgcy-lookbook]').forEach(function (track) {
      if (track._lgcyLb) return;
      track._lgcyLb = true;
      var isDown = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      var pauseUntil = 0;
      track.addEventListener('pointerdown', function (e) {
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        pauseUntil = Date.now() + 2600;
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) {
          moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
        }
        if (moved) track.scrollLeft = startScroll - dx;
      });
      function release() {
        isDown = false;
        track.classList.remove('is-dragging');
        pauseUntil = Date.now() + 2600;
      }
      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); moved = false; }
      }, true);

      /* auto-scroll: items are rendered twice, so wrap at the halfway
         point for a seamless loop; pause on hover/drag/hidden tab */
      if (track.hasAttribute('data-lgcy-autoscroll') && !reduceMotion) {
        var speed = (parseInt(track.getAttribute('data-lgcy-autoscroll'), 10) || 2) * 0.35;
        var hovering = false;
        track.addEventListener('mouseenter', function () { hovering = true; });
        track.addEventListener('mouseleave', function () { hovering = false; });
        function auto() {
          if (!isDown && !hovering && Date.now() > pauseUntil && !document.hidden) {
            var half = track.scrollWidth / 2;
            track.scrollLeft += speed;
            if (half > 0 && track.scrollLeft >= half) {
              track.scrollLeft -= half;
            }
          }
          requestAnimationFrame(auto);
        }
        requestAnimationFrame(auto);
      }
    });
  }

  /* ---- outline type: *word* markers in headings ---- */
  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function initOutline(root) {
    (root || document).querySelectorAll('.lgcy-h2, .lgcy-h3, .lgcy-cd__heading, .lgcy-404__title, .lgcy-about__statement, .lgcy-pban__heading').forEach(function (el) {
      if (el.dataset.lgcyO) return;
      el.dataset.lgcyO = '1';
      var txt = el.textContent;
      if (txt.indexOf('*') === -1) return;
      var parts = txt.split('*');
      var html = '';
      for (var i = 0; i < parts.length; i++) {
        html += i % 2 ? '<span class="lgcy-o">' + esc(parts[i]) + '</span>' : esc(parts[i]);
      }
      el.innerHTML = html;
    });
  }

  /* ---- hero heading word split ---- */
  function initSplit(root) {
    (root || document).querySelectorAll('[data-lgcy-split]').forEach(function (el) {
      if (el.dataset.lgcySplitDone || reduceMotion) return;
      el.dataset.lgcySplitDone = '1';
      var words = el.textContent.trim().split(/\s+/);
      var html = '';
      for (var i = 0; i < words.length; i++) {
        html += '<span class="w"><span class="wi" style="--wi: ' + i + ';">' + esc(words[i]) + '</span></span>' + (i < words.length - 1 ? ' ' : '');
      }
      el.innerHTML = html;
      el.classList.add('lgcy-split');
    });
  }

  /* ---- image reveal wipes ----
     Note: the clip is applied to the INNER image, never the observed
     container — clip-path collapses the visible box, which would keep
     both IntersectionObserver and native lazy-loading from ever firing. */
  function initWipes(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var targets = (root || document).querySelectorAll('.lgcy-story__figure, .lgcy-look__stage, .lgcy-bundle__media, .lgcy-about__portrait');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lgcy-wipe-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) {
      if (el.dataset.lgcyWipe) return;
      el.dataset.lgcyWipe = '1';
      el.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
      el.classList.add('lgcy-wipe');
      io.observe(el);
    });
  }

  /* ---- cart icon bump ---- */
  function initCartBump() {
    var host = document.querySelector('cart-icon') || document.querySelector('.header-actions [href*="/cart"]');
    if (!host || host._lgcyBump) return;
    host._lgcyBump = true;
    var mo = new MutationObserver(function () {
      host.classList.remove('lgcy-bump');
      void host.offsetWidth;
      host.classList.add('lgcy-bump');
    });
    mo.observe(host, { subtree: true, childList: true, characterData: true });
  }

  function boot() {
    initCountdowns();
    initLookbooks();
    initOutline();
    initSplit();
    initWipes();
    initCartBump();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initCountdowns(e.target);
    initLookbooks(e.target);
    initOutline(e.target);
    initSplit(e.target);
    initWipes(e.target);
  });
})();
